import React from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Linda was thorough, responsive and knowledgeable, making the entire process smooth and stress free.',
  name: 'Sarah & Michael',
  location: 'Carlton'
}, {
  quote: 'Fast, efficient and PERSONAL! They do not treat you like another transaction.',
  name: 'Mitchell',
  location: 'Melbourne'
}];
export function Proof() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-cream" data-id="element-328">
      <div className="max-w-7xl mx-auto" data-id="element-329">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12" data-id="element-330">
          <div data-id="element-331">
            <p className="text-accent font-script text-2xl mb-1" data-id="element-332">
              in their words
            </p>
            <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-333">
              What clients value.
            </h2>
            <div className="mt-4 flex items-center gap-3" data-id="element-334">
              <div className="flex text-accent" data-id="element-335">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" fill="currentColor" data-id="element-336" />)}
              </div>
              <span className="font-semibold text-ink" data-id="element-337">5.0 Google rating</span>
              <span className="text-muted-ink" data-id="element-338">·</span>
              <span className="text-muted-ink" data-id="element-339">10 reviews</span>
            </div>
          </div>

          <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-semibold text-brand-blue hover:text-brand-blue-dark transition-colors" data-id="element-340">
            Read Google reviews
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-341">
          {TESTIMONIALS.map(t => <figure key={t.name} className="relative rounded-3xl bg-surface border border-border p-8 md:p-10 shadow-card" data-id="element-342">
              <Quote className="w-9 h-9 text-accent/25 mb-4" fill="currentColor" data-id="element-343" />
              <blockquote className="font-serif text-xl md:text-2xl text-ink leading-snug" data-id="element-344">
                {t.quote}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3" data-id="element-345">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-accent-soft text-accent font-serif text-lg" data-id="element-346">
                  {t.name.charAt(0)}
                </span>
                <span data-id="element-347">
                  <span className="block font-semibold text-ink" data-id="element-348">{t.name}</span>
                  <span className="block text-sm text-muted-ink" data-id="element-349">
                    {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-5 text-xs text-muted-ink" data-id="element-350">
          Client feedback published on the existing website.
        </p>
      </div>
    </section>;
}